import _ from 'lodash';
import { PRODUCT_TYPES, TRADE_TYPES } from 'v2/common/constants/index';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { getSelectorBasedStoreValue } from 'v2/modules/withRunForm/redux/selector';
import ErrorMessage from 'v2/common/components/ErrorMessage';
import classNames from 'classnames';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const propTypes = {
  product: PropTypes.string.isRequired,
  onChangeProduct: PropTypes.func.isRequired,
};

const defaultProps = {};

const ProductType = ({ product, onChangeProduct }) => {
  const { positional } = TRADE_TYPES;
  const { errors, register, trigger } = useFormContext();
  const tradingType = useSelector((state) => getSelectorBasedStoreValue(state, 'quantConfig.tradingType'));
  const validatorConfig = {
    validate: (value) => {
      if (!value) return '*value required';
      if (value === PRODUCT_TYPES.mis.value && tradingType === positional.value)
        return '*MIS is for Intraday';

      return null;
    },
  };
  const radioBtnStyle = classNames('form-check-input', { 'is-invalid': !!errors.productType });

  const renderRadioBtn = (optionType) => (
    <div className="form-check form-check-sm d-flex align-items-center" key={optionType.value}>
      <input
        ref={register(validatorConfig)}
        className={radioBtnStyle}
        type="radio"
        name="productType"
        id={`product-type-${optionType.value}`}
        value={optionType.value}
        tabIndex="-100"
        checked={optionType.value === product}
        onChange={(e) => {
          onChangeProduct(e.target.value);
          trigger('productType');
        }}
      />
      <label className="form-check-label" htmlFor={`product-type-${optionType.value}`}>
        {optionType.label}
      </label>
    </div>
  );

  const renderErrorMessage = () => {
    if (!errors.productType) return null;

    const { message } = errors.productType;

    return <ErrorMessage message={message} />;
  };
  const sanitizedProductType = ApplicationDomainUtility.renameProductType(PRODUCT_TYPES);

  return (
    <>
      <div className="row align-items-center mb-4">
        <div className="col-md-2">
          <label className="label_style">Product Type</label>
        </div>
        <div className="col-md-10 d-flex gap-20">
          {_.map(PRODUCT_TYPES, renderRadioBtn)}
          {renderErrorMessage()}
        </div>
      </div>
    </>
  );
};

ProductType.propTypes = propTypes;
ProductType.defaultProps = defaultProps;

export default ProductType;
